import { render, staticRenderFns } from "./StaticRouteList.vue?vue&type=template&id=901335f0&scoped=true&"
import script from "./StaticRouteList.vue?vue&type=script&lang=js&"
export * from "./StaticRouteList.vue?vue&type=script&lang=js&"
import style0 from "./StaticRouteList.vue?vue&type=style&index=0&id=901335f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "901335f0",
  null
  
)

export default component.exports